import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'

export const Upgrade = ({ text }) => {
  return (
    <Element
      className="textCenter"
      style={{
        color: '#9C9C9C',
        padding: '18px 0 22px',
        transform: 'skew(-15deg)',
      }}
    >
      <Translate dangerousHTML value={text} />
    </Element>
  )
}

Upgrade.propTypes = {
  text: PropTypes.string.isRequired,
}
